module.exports = __webpack_public_path__ + "img/abo8.7d0b5aa8.jpg";